
import React, { Component, useState, useEffect, useContext } from "react";
import { Cookies } from '../../../../index.js';
import { useNavigate, Link, useLocation } from "react-router-dom";
import StatusBadge from "../../../../js/buttonstatus.jsx";
import AdSense from 'react-adsense';
import { alert_error, alert_success } from '../../../../AppContext';
import axios from "axios";
import queryString from 'query-string';
import { FaEdit } from 'react-icons/fa';
import Select from "react-select";
import ToggleButton from '../../../../app_structure/toggleButton.jsx';
import { ClipLoader, PulseLoader } from 'react-spinners';
const Account_edit = ({ item_account, showedit, setshowedit, category_main, get_lists_data }) => {
    const [chedo, setchedo] = useState('');
    const [note, setnote] = useState('');
    const [newbie_buff, set_newbie_buff] = useState('YES');
    const [nutxuly, setnutxuly] = useState(0);
    const [nutorder, setnutorder] = useState('✔️ Click to Confirm');
    const [amount, setamount] = useState(false);
    const [idlink, setidlink] = useState(false);
    const [accounts_vip_now, set_accounts_vip_now] = useState('');
    const [rawText, set_rawText] = useState();   // hiển thị trong textarea
    const [lines, set_lines] = useState([]);       // mảng sạch lưu/gửi

    const [item_account_edit, set_item_account_edit] = useState(true);

    function saochep(value) {
        alert_success('Đã sao chép');
        window.saochepnative(value);

    };

    const exitedit = () => {
        setshowedit(false);
    };

    function handleSubmit(event) {
        setnutxuly(1);
        event.preventDefault();
        setnutorder('Please wait a moment 😊');
        if ((!item_account.id || !rawText) && !item_account_edit.accounts_caption) {
            alert_error('Please điền đầy đủ thông tin')
            setnutxuly(0);
            setnutorder('điền đủ thông tin');
            return
        }
        if (category_main == 'accounts_services') {
            edit_services();
        } else if (category_main == 'accounts_seller') {
            if (item_account.accounts_type == 'local') {
                edit_accounts();
            } else if (item_account.accounts_type == 'api') {
                edit_mode_api();
            }
        }
    };
    function edit_services() {
        const apikey = Cookies.get('apikey');
        axios
            .post('https://hust.media/api/orders/account/sellers/services/accounts_edit.php', {
                apikey: apikey,
                id_accounts_main: item_account.id,
                accounts_mode: category_main,
                accounts_caption: item_account_edit.accounts_caption,
                accounts_description: item_account_edit.accounts_description,
                accounts_price: item_account_edit.accounts_price,
                accounts_type: item_account_edit.accounts_type,
                accounts_status: item_account_edit.accounts_status
            })
            .then(
                response => (testFunction(response))
            )
            .catch(error => alert_error(error))
    }
    function edit_accounts() {
        const apikey = Cookies.get('apikey');
        axios
            .post('https://hust.media/api/orders/account/sellers/services/accounts_edit.php', {
                apikey: apikey,
                id_accounts_main: item_account.id,
                accounts_mode: category_main,
                accounts_vip_now: accounts_vip_now,
                accounts_type: item_account_edit.accounts_type,
                accounts_status: item_account_edit.accounts_status

            })
            .then(
                response => (testFunction(response))
            )
            .catch(error => alert_error(error))
    }
    function edit_mode_api() {
        const apikey = Cookies.get('apikey');
        axios
            .post('https://hust.media/api/orders/account/sellers/services/accounts_edit.php', {
                apikey: apikey,
                id_accounts_main: item_account.id,
                accounts_amount: item_account_edit.accounts_amount,
                accounts_mode: category_main,
                accounts_type: item_account_edit.accounts_type,
                accounts_price: item_account_edit.accounts_price,
                accounts_status: item_account_edit.accounts_status

            })
            .then(
                response => (testFunction(response))
            )
            .catch(error => alert_error(error))
    }
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;
        setnutorder('đặt tiếp luôn nào')
        setnutxuly(0);
        if (status == 0) {
            alert_error(info.message);
        }
        else if (status == 1) {
            get_lists_data();
            alert_success(info.message);
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }
    };
    const location = useLocation();
    useEffect(() => {
        // Xử lý sự kiện khi location thay đổi, ví dụ:
        console.log('Đã thay đổi đường dẫn:', location.pathname);
    }, [location]);
    useEffect(() => {
        if (item_account) {
            set_rawText('');
            set_lines([]);
            set_item_account_edit(item_account);
            try {
                const parsed = JSON.parse(item_account.accounts_vip_now);
                set_accounts_vip_now(parsed);
            } catch (e) {
                console.error("❌ Lỗi parse accounts_vip_now:", item_account.accounts_vip_now, e);
                // Nếu không phải JSON thì coi như string
                set_accounts_vip_now("");
            }
        }
    }, [item_account]);


    const hamcancode = (key, value) => {
        set_item_account_edit(prev => ({
            ...prev,
            [key]: value, // cập nhật đúng field theo key
        }));
    };


    // Init 1 lần khi load hoặc khi item_account_edit thay đổi hoàn toàn
    useEffect(() => {
        if (!item_account_edit) return;

        // Nếu user đã bắt đầu gõ (rawText != ""), thì không ghi đè
        if (rawText && rawText.length > 0) return;

        const v = item_account_edit.accounts_vip_now;
        if (!v) {
            set_lines([]);
            set_rawText("");
            return;
        }

        try {
            const parsed = JSON.parse(v);
            if (Array.isArray(parsed)) {
                set_lines(parsed);
                set_rawText(parsed.join("\n")); // set lần đầu, có newline hiển thị
            } else {
                // nếu không phải mảng JSON, coi nó là chuỗi text
                set_lines([]);
                set_rawText(String(v));
            }
        } catch (err) {
            // không phải JSON -> cho thẳng vào textarea (giữ nguyên xuống dòng nếu có)
            set_lines([]);
            set_rawText(String(v));
        }
    }, [item_account_edit]); // lưu ý: không include rawText để tránh loop

    const handleTextareaChange = (event) => {
        const text = event.target.value;
        // luôn cập nhật rawText để textarea hiển thị chính xác, kể cả dòng trống
        set_rawText(text);
        // tách theo dòng, bỏ dòng trống
        const lines = text.split(/\r?\n/).filter(line => line.trim() !== "");

        // chỉ cần mảng string
        set_accounts_vip_now(lines);
    };

    // Clean và gửi khi user rời textarea (onBlur) hoặc khi nhấn nút Save
    const handleTextareaBlurOrSave = () => {
        const cleaned = rawText
            .split("\n")
            .map(line => line.trim())
            .filter(line => line !== "");
        set_lines(cleaned);
        // gửi dạng JSON string như bạn cần
        hamcancode("accounts_vip_now", JSON.stringify(cleaned));
        console.log("Saved JSON:", JSON.stringify(cleaned));
    };

    return (
        <>
            <div className="mt-1 mb-1 max-h-16">
                <div className="cards">
                    <AdSense.Google
                        client="ca-pub-4574266110812955"
                        slot="1627514116"
                        style={{ display: 'block' }}
                        format='horizontal'
                        responsive='false'
                    /></div>
            </div>
            {
                (showedit && item_account) &&
                (<>
                    <form onSubmit={(e) => e.preventDefault()} className="mx-2 mb-1 add-form">
                        <div className="form-control">
                            <div className='flex items-center justify-between flex-1'>
                                <label className="mb-2 text-lg">Chỉnh sửa account: {item_account.id} </label>
                                <label onClick={exitedit} className="mb-2 px-2 ">Đóng</label>
                            </div>
                            {category_main == 'accounts_services' && (<>
                                <label>Sửa tiêu đề</label>
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping">
                                        name
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Có thể bỏ trống"
                                        aria-label="name"
                                        value={item_account_edit.accounts_caption}
                                        name="name"
                                        aria-describedby="addon-wrapping"
                                        onChange={e => hamcancode("accounts_caption", e.target.value)}
                                    />
                                </div>
                                <label>Sửa mô tả</label>
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping">
                                        note
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Có thể bỏ trống"
                                        aria-label="description"
                                        value={item_account_edit.accounts_description}
                                        name="description"
                                        aria-describedby="addon-wrapping"
                                        onChange={e => hamcancode("accounts_description", e.target.value)}
                                    />
                                </div>
                                <label>Sửa tiền bán</label>
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping">
                                        price
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Có thể bỏ trống"
                                        aria-label="price"
                                        value={item_account_edit.accounts_price}
                                        name="price"
                                        aria-describedby="addon-wrapping"
                                        onChange={e => hamcancode("accounts_price", e.target.value)}
                                    />
                                </div>
                                <label className="text-base">Hình thức bán</label>
                                <div className="mb-1 space-y-2">
                                    <label className={`flex items-center p-2 border rounded cursor-pointer transition ${item_account_edit.accounts_type === 'local' ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-gray-400'}`}>
                                        <input
                                            type="radio"
                                            name="recharge"
                                            value={'local'}
                                            checked={item_account_edit.accounts_type === 'local'}
                                            onChange={e => hamcancode("accounts_type", e.target.value)}
                                            className="form-radio h-4 w-4 text-blue-600"
                                        />
                                        <span className="ml-2 text-gray-700">Thủ công qua Hust</span>
                                    </label>

                                    <label className={`flex items-center p-2 border rounded cursor-pointer transition ${item_account_edit.accounts_type === 'api' ? 'border-blue-500 bg-blue-50' : 'border-gray-300 hover:border-gray-400'}`}>
                                        <input
                                            type="radio"
                                            name="recharge"
                                            value={'api'}
                                            checked={item_account_edit.accounts_type === 'api'}
                                            onChange={e => hamcancode("accounts_type", e.target.value)}
                                            className="form-radio h-4 w-4 text-blue-600"
                                        />
                                        <span className="ml-2 text-gray-700">Tự động qua Api</span>
                                    </label>
                                </div>
                                <label className="text-base">Trạng thái bán</label>
                                <div className="mb-3">
                                    <button
                                        type="button"
                                        onClick={() =>
                                            hamcancode(
                                                "accounts_status",
                                                item_account_edit.accounts_status === 'Canceled' ? 'Completed' : 'Canceled'
                                            )
                                        }
                                        className={`w-full flex items-center justify-between p-2 border rounded transition ${
                                            item_account_edit.accounts_status === 'Canceled'
                                                ? 'border-red-500 bg-red-50 text-red-700'
                                                : 'border-green-500 bg-green-50 text-green-700'
                                        }`}
                                    >
                                        <span>
                                            {item_account_edit.accounts_status === 'Canceled' ? 'Đã hủy bán' : 'Đang bán'}
                                        </span>
                                        <span className="text-xs">
                                            Nhấn để {item_account_edit.accounts_status === 'Canceled' ? 'mở bán' : 'hủy bán'}
                                        </span>
                                    </button>
                                </div>
                            </>
                            )}
                            {category_main == 'accounts_seller' && (
                                <>
                                    {item_account.accounts_type === "local" ? (
                                        <>
                                            <label>Sửa tk đang bán</label>
                                            <div>Mỗi tài khoản 1 dòng</div>
                                            <div className="input-group flex-nowrap">
                                                <span className="input-group-text" id="addon-wrapping">
                                                    =))
                                                </span>
                                                <textarea
                                                    className="form-control"
                                                    placeholder="ex: usersname|passwords"
                                                    aria-label="accounts_vip_now"
                                                    value={rawText}               // HIỂN THỊ chính xác, có newline
                                                    onChange={handleTextareaChange}
                                                    onBlur={handleTextareaBlurOrSave} // lưu sạch khi rời
                                                    rows={6}
                                                />
                                            </div>
                                        </>
                                    ) : item_account.accounts_type === "api" ? (
                                        <>
                                            <label>Sửa số lượng hiện có</label>
                                            <div className="input-group flex-nowrap">
                                                <span className="input-group-text" id="addon-wrapping">
                                                    name
                                                </span>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Có thể bỏ trống"
                                                    aria-label="name"
                                                    value={item_account_edit.accounts_amount}
                                                    name="name"
                                                    aria-describedby="addon-wrapping"
                                                    onChange={e => hamcancode("accounts_amount", e.target.value)}
                                                />
                                            </div>
                                            <label>Sửa tiền bán</label>
                                            <div className="input-group flex-nowrap">
                                                <span className="input-group-text" id="addon-wrapping">
                                                    price
                                                </span>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Có thể bỏ trống"
                                                    aria-label="price"
                                                    value={item_account_edit.accounts_price}
                                                    name="price"
                                                    aria-describedby="addon-wrapping"
                                                    onChange={e => hamcancode("accounts_price", e.target.value)}
                                                />
                                            </div>
                                        </>
                                    ) : null}
                                </>
                            )}
                            <button disabled={nutxuly == 1} onClick={handleSubmit}
                                className='mt-3 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-3 w-full dark:bg-slate-800 dark:text-white'>
                                <div className='flex items-center justify-between flex-1'>
                                    {nutxuly == 1 &&
                                        <div className="spinner-border" role="status">

                                        </div>}


                                    <span className='text-lg font-medium text-white'>
                                        {nutorder} </span>
                                    <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                                </div>
                            </button>
                        </div>
                    </form>

                </>)
            }
        </>
    );
};

export default Account_edit;
